import React, { forwardRef, useEffect, useRef } from "react";

const AutoHideScrollContainer = forwardRef(
  ({ children, className = "", persistentScrollbar = false }, ref) => {
    const scrollableRef = useRef(null);

    const setScrollRef = (node) => {
      scrollableRef.current = node;
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    };

    useEffect(() => {
      if (persistentScrollbar) {
        return undefined;
      }

      let hideTimer;
      const handleScroll = (e) => {
        e.target.style.marginRight = "0px";
        e.target.style.paddingRight = "0px";
        clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
          e.target.style.marginRight = "-20px";
          e.target.style.paddingRight = "20px";
        }, 800);
      };

      const node = scrollableRef.current;
      node?.addEventListener("scroll", handleScroll);

      return () => {
        clearTimeout(hideTimer);
        node?.removeEventListener("scroll", handleScroll);
      };
    }, [persistentScrollbar]);

    return (
      <div className={className} style={{ overflow: "hidden" }}>
        <div
          ref={setScrollRef}
          className={persistentScrollbar ? "rc-scroll-visible" : undefined}
          style={{
            overflowY: "auto",
            overflowX: "hidden",
            paddingRight: persistentScrollbar ? "2px" : "20px",
            marginRight: persistentScrollbar ? "0" : "-20px",
          }}
        >
          {children}
        </div>
      </div>
    );
  }
);

AutoHideScrollContainer.displayName = "AutoHideScrollContainer";

export default AutoHideScrollContainer;
